import { IFilterSet, IOption, MultiSelect } from '../typings'
import { IPropertyFilter } from '../typings/IPropertyFilter'

export const singleToMultiSelectFields: string[] = [
  'salesTeamId',
  'salesFunnelId',
]

export function transformSelectSingleToMultiValues<U, T extends IFilterSet<U>>(
  parsedFilters: any,
  inputField: string,
  prev: T['filters'],
  filter: IPropertyFilter<U>,
) {
  const shouldUpdateValueDefault =
    filter.type == 'multiSelect' &&
    !(
      parsedFilters[inputField].value.options &&
      Array.isArray(parsedFilters[inputField].value.options)
    )
  const shouldUpdateValue =
    inputField == 'salesTeamId'
      ? !parsedFilters['salesTeamIds'] && shouldUpdateValueDefault
      : shouldUpdateValueDefault

  const stValue = deserializeMultiSelect(parsedFilters[inputField].value)
  const outputFieldName: string =
    inputField == 'salesTeamId' ? 'salesTeamIds' : inputField
  return {
    ...prev,
    [outputFieldName]: {
      ...filter,
      value: shouldUpdateValue
        ? { ...stValue }
        : parsedFilters[inputField].value,
    },
  }
}

export const deserializeMultiSelect = (option: IOption): MultiSelect => {
  return {
    mode: 'any',
    options: [{ ...option }],
  }
}
